import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=7f919076&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=7f919076&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f919076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f919076')) {
      api.createRecord('7f919076', component.options)
    } else {
      api.reload('7f919076', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=7f919076&scoped=true", function () {
      api.rerender('7f919076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Documents/Documents.vue"
export default component.exports